import EnvXAPI from '../xapis/EnvXAPI';

export default function isProduction(): boolean {
  return EnvXAPI.REACT_APP_NODE_ENV === 'production';
}
